import { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Combobox } from "@/components/Combobox";
import { toast } from "sonner";
import { Download, FileSpreadsheet, FileText, Loader2, X } from "lucide-react";

const FORMATOS = [["csv", "CSV", FileText], ["xlsx", "Excel", FileSpreadsheet], ["pdf", "PDF", Download]];

/** Filtros do histórico (entregador + período do registro) e botões de exportação CSV / XLSX / PDF. */
export function AcertosHistoricoFiltros({ entregadores, filtros, setFiltros, total }) {
  const [busy, setBusy] = useState(null);
  const invalido = filtros.start && filtros.end && filtros.start > filtros.end;
  const limpar = () => setFiltros({ entregador_id: "", start: "", end: "" });
  const exportar = async (formato) => {
    setBusy(formato);
    try {
      const params = { formato, ...Object.fromEntries(Object.entries(filtros).filter(([, v]) => v)) };
      const r = await api.get("/acertos/export", { params, responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement("a"); a.href = url;
      a.download = `acertos_${new Date().toISOString().slice(0, 10)}.${formato}`;
      document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(url);
      toast.success(`Histórico exportado em ${formato.toUpperCase()}`);
    } catch (e) {
      let msg = "Erro ao exportar";
      try { if (e?.response?.data instanceof Blob) msg = JSON.parse(await e.response.data.text())?.detail || msg; } catch (err) { console.debug("resposta de erro sem JSON", err); }
      toast.error(msg);
    } finally { setBusy(null); }
  };
  return (
    <div className="flex flex-wrap items-end gap-2 mb-2" data-testid="acertos-hist-filtros">
      <div className="w-56">
        <Label className="text-[11px]">Entregador</Label>
        <Combobox options={entregadores} value={filtros.entregador_id} onChange={(v) => setFiltros({ ...filtros, entregador_id: v || "" })}
          placeholder="Todos" testId="acertos-hist-entregador" />
      </div>
      <div>
        <Label className="text-[11px]">Registrado de</Label>
        <Input type="date" className="h-9 w-36" value={filtros.start} onChange={(e) => setFiltros({ ...filtros, start: e.target.value })} data-testid="acertos-hist-start" />
      </div>
      <div>
        <Label className="text-[11px]">até</Label>
        <Input type="date" className="h-9 w-36" value={filtros.end} onChange={(e) => setFiltros({ ...filtros, end: e.target.value })} data-testid="acertos-hist-end" />
      </div>
      {(filtros.entregador_id || filtros.start || filtros.end) && (
        <Button variant="ghost" size="sm" className="h-9" onClick={limpar} data-testid="acertos-hist-limpar"><X className="w-3.5 h-3.5 mr-1" />Limpar</Button>
      )}
      <div className="ml-auto flex items-center gap-1.5">
        <span className="text-xs text-muted-foreground mr-1" data-testid="acertos-hist-total">{total} acerto(s)</span>
        {FORMATOS.map(([k, l, Icon]) => (
          <Button key={k} size="sm" variant="outline" className="h-9" onClick={() => exportar(k)} disabled={!!busy || invalido || total === 0}
            title={`Exportar histórico em ${l}`} data-testid={`acertos-export-${k}`}>
            {busy === k ? <Loader2 className="w-3.5 h-3.5 mr-1 animate-spin" /> : <Icon className="w-3.5 h-3.5 mr-1" />}{l}
          </Button>
        ))}
      </div>
      {invalido && <div className="w-full text-xs text-rose-700" data-testid="acertos-hist-invalido">Data inicial maior que a final.</div>}
    </div>
  );
}
